import storage from "@/services/storage";
import axios from 'axios'
import router from 'src/router'
import { getCurrentLocale } from 'src/helpers/functions'

const BASE_URL = process.env.VUE_APP_API_ORGADMIN;
const language = getCurrentLocale();
let is403AlertShown = false;

export const headerOrgAdmin = () => {
  return {
    Authorization: "Bearer " + storage.get("token"),
    "Content-Type": "application/json"
  };
};

export const headerOrgAdminAxios = () => {
  const api = axios.create({
    credentials: "include",
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': language,
    }
  })

  api.interceptors.request.use(function (config) {
    const token = storage.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  })


  api.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      const status = error?.response?.status

      if (status === 401) {
        storage.remove('token')
        store.dispatch('user/logout')
      }

      if ((status === 403 || status === 406) && !is403AlertShown) {
        is403AlertShown = true
        router.push({name: "Home"})
        router.app?.$toasted?.error(i18n.t("no_permission"), {
          position: "bottom-right",
          duration: 3000,
        })
        return;
      }

      return Promise.reject(error)
    }
  )

  return api
};
